export function mock(data) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve({ data });
    }, Math.random() * 1000);
  });
}
